export const appConstants = {
    CHANGE_LANGUAGE_REQUEST: 'APP_CHANGE_LANGUAGE_REQUEST',
};
